/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Spin, Table, Tooltip } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  FileExcelFilled,
  FilePdfOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import "../Styles/AuditTable.css";
import { useDispatch, useSelector } from "react-redux";
import Axios from "../../../../../api/Axios";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../../components/icons/ApplicationColor";
import { setEmailFilterDataRedux } from "../../../../../store/slices/emailfilterSlice";
import EmailFilterModal from "../Modals/EmailFilterModal";
import { BASE_URL } from "../../../../../config";
import CommonTopDetails from "../../../../../components/AdminComponents/CommonTopDetails";

const EmailTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [emailStatus, setEmailStatus] = useState("");
  const [L1Filters, setL1Filters] = useState([]);
  const [L2Filters, setL2Filters] = useState([]);
  const [L3Filters, setL3Filters] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [searchString, setSearchString] = useState("");
  // const [l1name, setL1name] = useState("")
  // const [l2name, setL2name] = useState("")
  // const [l3name, setL3name] = useState("")
  const [itemsLength, setItemsLength] = useState(0);
  const [selectedL1Filter, setselectedL1Filter] = useState(null);
  const [selectedL2Filter, setselectedL2Filter] = useState(null);
  const [selectedL3Filter, setselectedL3Filter] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [pageChanged, setPageChanged] = useState(false);

  const clientInfo = useSelector((state) => state.user);
  const id = clientInfo.data.organization.id;
  const filterDataRedux = useSelector((state) => state.emailfilter);
  const dispatch = useDispatch();
  const { search, l1name, l2name, l3name, pageSize, currentPage } =
    filterDataRedux;

  const handleStatusChange = (emailStatus) => {
    // dispatch(
    //   setEmailFilterDataRedux({
    //     email_status : emailStatus
    //   })
    // )
  };

  const onShowSizeChange = (page, size) => {
    //console.log(size, "clientFilter");
    dispatch(
      setEmailFilterDataRedux({
        ...filterDataRedux,
        pageSize: size,
        newPageSize: Math.random(),
      })
    );
    onPageChange(page, size);
  };

  const onPageChange = (page, size) => {
    setPageChanged(true);
    dispatch(
      setEmailFilterDataRedux({
        ...filterDataRedux,
        currentPage: page,
        pageSize: size,
      })
    );
  };

  const L1Filter = async () => {
    try {
      const res = await Axios.get(`/hirarchylist/?hierarchy=Level1&find=${id}`);
      setL1Filters(res.data.structure);
      dispatch(
        setEmailFilterDataRedux({
          l1filters: res.data.structure,
          l1name: l1name,
          l2name: l2name,
          l3name: l3name,
        })
      );
    } catch (err) {
      console.error(err);
    }
  };

  const L2Filter = async () => {
    if (selectedL1Filter) {
      try {
        const res = await Axios.get(
          `/hirarchylist/?hierarchy=Level2&find=${selectedL1Filter}`
        );
        setL2Filters(res.data.structure);
        setselectedL2Filter(res.data.structure[0].id);
        dispatch(
          setEmailFilterDataRedux({
            selectedl1filters: selectedL1Filter,
          })
        );
        L3Filter();
      } catch (err) {
        console.error(err);
      }
    }
  };

  const L3Filter = async () => {
    if (selectedL2Filter) {
      try {
        const res = await Axios.get(
          `/hirarchylist/?hierarchy=Level3&find=${selectedL2Filter}`
        );
        setL3Filters(res.data.structure);
        setselectedL3Filter(res.data.structure[0].id);
        dispatch(
          setEmailFilterDataRedux({
            selectedl2filters: selectedL2Filter,
          })
        );
      } catch (err) {
        console.error(err);
      }
    }
  };

  const ResetFields = () => {
    setL2Filters([]);
    setL3Filters([]);
    setselectedL1Filter(null);
    setselectedL2Filter(null);
    setselectedL3Filter(null);
    let randomItemsLength = Math.floor(Math.random() * 100);
    setEmailStatus("");
    dispatch(
      setEmailFilterDataRedux({
        ...filterDataRedux,
        pageSize: 15,
        currentPage: 1,
        url: `/seslog/${id}`,
        filter_flag: false,
        search: "",
        email_status: "",
        itemsLength: randomItemsLength,
      })
    );
    fetchEmailData();
    setVisible(false);
  };

  const handleApply = async () => {
    //console.log("IN HANDLE APPLY");
    setLoading(true);
    dispatch(
      setEmailFilterDataRedux({
        email_status: emailStatus,
      })
    );
    let passUrl = `/seslog/${id}/?email_status=${emailStatus}`;
    if (!selectedL1Filter) {
      passUrl += `&page=${currentPage}&page_size=${pageSize}`;
    } else {
      passUrl += `&page=1&page_size=15`;
    }
    if (selectedL1Filter) {
      passUrl += `&entity_id=${selectedL1Filter}`;
    }
    if (selectedL2Filter) {
      passUrl += `&division_id=${selectedL2Filter}`;
    }
    if (selectedL3Filter) {
      passUrl += `&department_id=${selectedL3Filter}`;
    }

    try {
      const res = await Axios.get(passUrl);
      dispatch(
        setEmailFilterDataRedux({
          ...filterDataRedux,
          pageSize: 15,
          currentPage: 1,
        })
      );
      setData(res.data.results.data);
      setItemsLength(res.data.count);
      setVisible(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setVisible(true);
    handleStatusChange(emailStatus);
  };

  const fetchEmailData = async () => {
    const id = clientInfo.data.organization.id;
    let passUrl = `/seslog/${id}/?page=${currentPage}&page_size=${pageSize}`;
    if (search && search.length > 2) {
      setSearchString(search);
      passUrl += `&search=${search}`;
    }
    setLoading(true);
    try {
      const res = await Axios.get(passUrl);
      setData(res.data.results.data);
      // setL1name(res.data.l1_name)
      // setL2name(res.data.l2_name)
      // setL3name(res.data.l3_name)
      setItemsLength(res.data.count);
      setLoading(false);
    } catch (err) {
      //console.log(err)
    } finally {
      L1Filter();
    }
  };
  // eslint-disable-next-line no-unused-vars
  const items = [
    {
      label: "PDF",
      key: "1",
      icon: <FilePdfOutlined />,
    },
    {
      label: "Excel",
      key: "2",
      icon: <FileExcelFilled />,
      disabled: true,
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const handleMenuClick = (e) => {
    console.log("Clicked", e);
    var url = `${BASE_URL}/generate/${clientInfo.data.organization.id}/email/pdf/?email_status=${emailStatus}`;
    if (selectedL1Filter) {
      url += `&entity_id=${selectedL1Filter}`;
    }
    if (selectedL2Filter) {
      url += `&division_id=${selectedL2Filter}`;
    }
    if (selectedL3Filter) {
      url += `&department_id=${selectedL3Filter}`;
    }
    var win = window.open(url, "_blank");
    win.focus();
  };
  // const menuProps = {
  //   items,
  //   onClick: handleMenuClick,
  // };
  const handleSearchChange = (event) => {
    setSearchString(event.target.value);
    dispatch(
      setEmailFilterDataRedux({
        ...filterDataRedux,
        search: event.target.value,
        currentPage: 1,
        url: "/seslog/",
      })
    );
  };

  useEffect(() => {
    fetchEmailData();
    // eslint-disable-next-line no-unused-vars
  }, []);

  useEffect(() => {
    fetchEmailData();
    // eslint-disable-next-line no-unused-vars
  }, [
    filterDataRedux.search,
    filterDataRedux.pageSize,
    filterDataRedux.currentPage,
  ]);

  useEffect(() => {
    L2Filter();
    // eslint-disable-next-line no-unused-vars
  }, [selectedL1Filter]);

  useEffect(() => {
    L3Filter();
    // eslint-disable-next-line no-unused-vars
  }, [selectedL2Filter]);

  const renderStatus = (text, record) => {
    if (record.email_status === "Delivery") {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tooltip title={record.email_status}>
              <CheckOutlined
                style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
              />
            </Tooltip>
          </div>
        </div>
      );
    } else if (record.email_status === "Delivery") {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tooltip title={record.email_status}>
              <CheckOutlined
                style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
              />
            </Tooltip>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tooltip title={record.email_status}>
              <CloseOutlined
                style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
              />
            </Tooltip>
          </div>
        </div>
      );
    }
  };

  const columns = [
    {
      title: capitalizeWords("EMAIL"),
      dataIndex: "email",
      key: "email",
    },
    {
      title: capitalizeWords("NAME"),
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: capitalizeWords(l3name),
      dataIndex: "department",
      key: "department",
    },
    {
      title: capitalizeWords("SENT TIME"),
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, record) => {
        const date = new Date(record.updated_at);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.updated_at) {
          return `${day} ${month} ${year} ${hours}:${minutes}:${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
    {
      title: capitalizeWords("EMAIL TYPE"),
      dataIndex: "type",
      key: "type",
    },
    {
      title: capitalizeWords("Email Status"),
      dataIndex: "email_status",
      key: "email_status",
    },
    {
      title: capitalizeWords("STATUS"),
      dataIndex: "email_status",
      key: "email_status",
      align: "center",
      render: renderStatus,
    },
    {
      title: capitalizeWords("EVENT"),
      dataIndex: "email_status",
      key: "email_status",
    },
  ];
  return (
    <>
      <CommonTopDetails
        title={"Email Logs"}
        titleSuffix={`${itemsLength || 0} client(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={true}
        marginPass="15px"
        filterUrl={false}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        resetButtonProps={{
          modalProps: ResetFields,
        }}
      />

      <Spin spinning={loading}>
        <Table
          size="small"
          rowKey="id"
          dataSource={data}
          columns={columns}
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            y: `${remainingViewportHeight(36)}px`,
            x: 1000,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={[10, 15, 30, 50, 100]}
            // showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            pageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>

      <EmailFilterModal
        visible={visible}
        l1Filters={L1Filters}
        l2Filters={L2Filters}
        l3Filters={L3Filters}
        l1name={l1name}
        l2name={l2name}
        l3name={l3name}
        handleCancel={() => {
          setVisible(false);
        }}
        handleApply={handleApply}
        selectedL1Filter={selectedL1Filter}
        selectedL2Filter={selectedL2Filter}
        selectedL3Filter={selectedL3Filter}
        setselectedL1Filter={setselectedL1Filter}
        setselectedL2Filter={setselectedL2Filter}
        setselectedL3Filter={setselectedL3Filter}
        fetchL2Filters={L2Filter}
        fetchL3Filters={L3Filter}
        emailStatus={emailStatus}
        setEmailStatus={setEmailStatus}
        ResetFields={ResetFields}
      />
    </>
  );
};

export default EmailTable;
